import { Route } from "react-router-dom";
import ProfitabilityPage from "./profitability-page";
import { PROFITABILITY_ROUTE_PATTERNS } from "./routes";

export const profitabilityRoutes = () =>
  PROFITABILITY_ROUTE_PATTERNS.map((path) => (
    <Route key={path} path={path} element={<ProfitabilityPage />} />
  ));
